module.exports = __webpack_public_path__ + "img/police_intro_1.a696cb6e.png";